module.exports = __webpack_public_path__ + "media/images/front/banner_premium_side-211ac9b2623765a71d6459ecb294ce57.png";